export default __webpack_public_path__ + "static/media/VAPLabs.3d490f7d.mov";